import TitleUpdater from '../../../../../utils/TitleUpdater';
import NewHero from './newhero';
import CloudOverview from './CloudOverview';
import CloudServices from './CloudServices';
import CloudOperations from './CloudOperations';
import CloudOutcomes from './CloudOutcomes';
import CloudTechnologyStacks from './CloudTechnologyStacks';
import CloudBenefits from './CloudBenefits';
import CloudFaqs from './CloudFaqs';

const colors = {
  text: '#212121',
};

export default function CloudMigrationManagedServices() {
  return (<main className="cloud-services-page font-['Be_Vietnam_Pro']" style={{ background: '#FFFFFF', color: colors.text, overflow: 'hidden' }}>
    <style>{`.cloud-services-page p { text-align: left; hyphens: none; word-spacing: normal; }
      .cloud-services-page .cloud-centered p { text-align: center; }`}</style>
    <TitleUpdater title="Cloud Migration & Managed Services" />

    <NewHero />


    {/* <CloudOverview /> */}

    <CloudServices />

    <CloudOperations />

    <CloudTechnologyStacks />


    <CloudBenefits />

{/* 
    <CloudOutcomes /> */}


    <CloudFaqs />
  </main>);
}
